const OAUTH_POST_LOGIN_REDIRECT_KEY = `vsly_oauth_post_login_redirect`;
const OAUTH_POST_LOGIN_REDIRECT_MAX_AGE_MS = 10 * 60 * 1000;

interface StoredOAuthRedirect {
  path: string;
  createdAt: number;
}

function validOAuthRedirect(stored: string | null): string | undefined {
  if (!stored) return undefined;
  try {
    const redirect = JSON.parse(stored) as StoredOAuthRedirect;
    const url = new URL(redirect.path, window.location.origin);
    const normalizedPath = url.pathname.replace(/\/$/, ``);
    if (
      url.origin !== window.location.origin ||
      normalizedPath !== `/oauth/authorize` ||
      !url.search ||
      !Number.isFinite(redirect.createdAt) ||
      Date.now() < redirect.createdAt ||
      Date.now() - redirect.createdAt > OAUTH_POST_LOGIN_REDIRECT_MAX_AGE_MS
    ) {
      return undefined;
    }
    return redirect.path;
  } catch {
    return undefined;
  }
}

export function rememberOAuthRedirect(): void {
  if (typeof window === `undefined`) return;
  if (!window.location.pathname.startsWith(`/oauth/authorize`)) return;
  const redirect: StoredOAuthRedirect = {
    path: `${window.location.pathname}${window.location.search}`,
    createdAt: Date.now(),
  };
  const stored = JSON.stringify(redirect);
  window.sessionStorage.setItem(OAUTH_POST_LOGIN_REDIRECT_KEY, stored);
}

export function consumeOAuthRedirect(): string | undefined {
  if (typeof window === `undefined`) return undefined;
  const stored = window.sessionStorage.getItem(OAUTH_POST_LOGIN_REDIRECT_KEY);
  window.sessionStorage.removeItem(OAUTH_POST_LOGIN_REDIRECT_KEY);
  const redirect = validOAuthRedirect(stored);
  return redirect;
}

export function hasPendingOAuthRedirect(): boolean {
  if (typeof window === `undefined`) return false;
  return !!validOAuthRedirect(
    window.sessionStorage.getItem(OAUTH_POST_LOGIN_REDIRECT_KEY),
  );
}

export function clearOAuthRedirect(): void {
  if (typeof window === `undefined`) return;
  window.sessionStorage.removeItem(OAUTH_POST_LOGIN_REDIRECT_KEY);
}
